<template>
    <v-table
        class="table-data"
        fixed-header>
        <thead>
        <tr>
            <th v-for="item in headers"
            :key="item" class="text-left">
            {{item}}
            </th>
        </tr>
        </thead>
        <tbody>
        <tr
          v-for="item in stock"
          :key="item._id">
          <td>{{formatTimestamp(item.updated_at) }}</td>
          <td>{{item.type == 'out' ? 'Salida':'Entrada'}}</td>
          <td>{{item.product_sku}}</td>
          <td>{{item.product_name}}</td>
          <td>{{item.quantity}}</td>
          <td>{{item.cost}}</td>
          <td>{{item.quantity * item.cost}}</td>
          <td>{{item.terminal_id.name}}</td>
          <td>
            <v-icon @click="editModal(item)">mdi-pencil-box-outline</v-icon>
            <v-tooltip location="bottom">
              <template #activator="{ props }">
                <v-icon
                  @click="editModal(item)"
                  v-bind="props"
                  :color="item.note !== '' ? '#FFA500' : '#5A5A5A'"
                  style="cursor: pointer;">
                  mdi-comment-outline
                </v-icon>
              </template>
              <span>{{ item.note }}</span>
            </v-tooltip>
          </td>
        </tr>
        </tbody>
    </v-table>

    <add-edit-stock
    v-if="filterData"
    ref="addEditModal"
    @refreshList="refresh"
    :terminals="filterData"/>
</template>

<script>
import terminalsApi from '@/api/terminalsApi'
import dateTransform from '@/utils/dateTransform'
import AddEditStock from '../forms/AddEditStock.vue'
export default {
  name: 'CommerciaVueStockTable',
  emits: ['refreshList'],
  components: {
    AddEditStock
  },
  props: {
    stock: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      headers: ['Fecha', 'Tipo', 'Sku', 'Producto', 'Unidades', 'Costo U.', 'Total', 'POS', 'Acciones'],
      filterData: [{ value: 'all', label: 'Todos' }],
      business: this.$store.getters.business
    }
  },
  mounted () {
    this.getPos()
  },
  methods: {
    editModal (item) {
      this.$refs.addEditModal.edit(item)
    },
    refresh () { this.$emit('refreshList') },
    formatTimestamp (timestamp) {
      return dateTransform.timestampToFormat(timestamp)
    },
    async getPos () {
      const listPos = await terminalsApi.list(this.business._id, '')
      for (const item of listPos) {
        this.filterData.push({ value: item._id, label: item.name })
      }
    }
  }
}
</script>

<style scoped>
  @import '@/assets/styles/tables.css';
</style>
